import log from 'loglevel';
import whenDomReady from 'when-dom-ready';

import settings from './settings';
import bootstrap from './bootstrap';

function index() {
  log.setDefaultLevel(settings.defaultLogLevel);

  return whenDomReady()
    .then(() => bootstrap());
}

index();

export default index;



// WEBPACK FOOTER //
// ./src/index.js